import copy from '../../demo/fixtures/w5/copy.json'
import { Card, CardHead, GlossaryText, Icon } from '../../ui'
import { useW5Live } from './live'
import styles from './AnalysisPage.module.css'

const ownerLabels = { ai: 'AI', you: '你' } as const

export function NextActions() {
  const { report } = useW5Live()
  return (
    <Card className={styles.section} data-scope="next-actions">
      <CardHead title={copy.sections.nextActions} subtitle={copy.sections.nextActionsHint} />
      <div className={styles.actionsBody}>
        <div className={styles.actions}>
          {report.actions.map((action) => {
            const owner = action.owner
            return (
              <div className={styles.action} key={`${action.owner}-${action.text}`}>
                <span className={`${styles.owner} ${styles[owner]}`}>
                  <Icon name={owner === 'ai' ? 'sparkle' : 'user'} size={12} strokeWidth={2} />
                  {ownerLabels[owner]}
                </span>
                <span><GlossaryText text={action.text} /></span>
                <span className={styles.actionWhen}>{action.when}</span>
              </div>
            )
          })}
        </div>
      </div>
    </Card>
  )
}
